// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"383":"applications","401":"merit","480":"mailing","562":"accounts","785":"staff","885":"downloads","909":"notifications"}[chunkId] || chunkId) + "." + {"383":"846bd863","401":"388f31a2","480":"50e40d1c","562":"8afeecbc","785":"6617daaa","885":"eeffdb08","900":"6dbb5e95","909":"58d5a0c2"}[chunkId] + ".js";
};